import { useSelector } from 'react-redux';

// Design system
import { Message } from 'jl-design-system/components/message/Message';

// Config
import payPalConnectMessageState from './PayPalConnectMessage.state';

// Components
import Container from '@components/container';

const PayPalConnectMessage = () => {
  const { showMessage } = useSelector(payPalConnectMessageState);

  return (
    showMessage && (
      <Container marginBottom="2">
        <Message
          body="Please consider using an alternative payment method."
          dataId="unable-connect-paypal"
          scrollToMessageOnMount
          title="Sorry, we've been unable to connect to PayPal"
          type="error"
        />
      </Container>
    )
  );
};

export default PayPalConnectMessage;
